import { Button, type ButtonProps } from "react-bootstrap";
import { MdCloudDownload } from "react-icons/md";

const ExportButton: TTButtonProps = ({ children, ...props }) => (
  <Button variant="primary" {...(props as ButtonProps)}>
    <MdCloudDownload /> {children}
  </Button>
);

export default ExportButton;
